function instanceOfPrimitive(object) {
  return typeof object === "string" || typeof object === "number" || typeof object === "boolean";
}
export {
  instanceOfPrimitive
};
